import helper from './helper'

const getAccountsUrlWithParameters = helper.getAccountsUrlWithParameters

export default {
  getAccountsUrlWithParameters,
  /**
   * Базовая функция для построения URL
   */
  getByRecievedUrlData: (url, gets = null) => getAccountsUrlWithParameters(
    /**
     * Функция для построения URL из предопределенного объекта URL
     * @param {Object} url - объект конфигурации URL
     * @param {Object} gets - дополнительные query параметры (опционально)
     * @returns {string} строка URL
     */
    url.basename,
    url.action,
    url.params,
    gets
  ),
  PASSWORD_POLICY:
    /**
     * Получает политику паролей
     * @param {Object} gets - дополнительные query параметры (опционально)
     * @returns {string} URL для получения политики паролей
     */
    (gets = null) => getAccountsUrlWithParameters(
      'users|user|get|password|policy',
      'get',
      {},
      gets
    ),
  PROFILE: {
    DETAIL:
      (user_uid, gets = null) => getAccountsUrlWithParameters(
        /**
         * Получает детальную информацию о пользователе
         * @param {string} user_uid - уникальный идентификатор пользователя
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для получения профиля пользователя
         */
        'users|user|profile',
        'get',
        { user_uid },
        gets
      ),
    CHANGE_AVATAR:
      (user_uid, gets = null) => getAccountsUrlWithParameters(
        /**
         * Изменяет аватар пользователя
         * @param {string} user_uid - уникальный идентификатор пользователя
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для изменения аватара
         */
        'users|user|profile|avatar|change',
        'put',
        { user_uid },
        gets
      ),
    CHANGE_EMAIL:
      /**
       * Изменяет почту пользователя
       * @param {string} user_uid - уникальный идентификатор пользователя
       * @param {Object} gets - дополнительные query параметры (опционально)
       * @returns {string} URL для изменения почты
       */
      (user_uid, gets = null) => getAccountsUrlWithParameters(
        'users|user|profile|email|change',
        'put',
        { user_uid },
        gets
      ),
    APPROVE_EMAIL:
      /**
       * Подтверждает почту пользователя
       * @param {Object} gets - дополнительные query параметры (опционально)
       * @returns {string} URL для подтверждения почты
       */
      (gets = null) => getAccountsUrlWithParameters(
        'users|user|profile|email|approve',
        'post',
        gets
      ),
    CHANGE_PASS:
      /**
       * Изменяет пароль пользователя
       * @param {string} user_uid - уникальный идентификатор пользователя
       * @param {Object} gets - дополнительные query параметры (опционально)
       * @returns {string} URL для изменения пароля
       */
      (user_uid, gets = null) => getAccountsUrlWithParameters(
        'users|user|profile|password|change',
        'put',
        { user_uid },
        gets
      ),
    STUDENT:
      /**
       * Получает профиль студента
       * @param {Object} gets - дополнительные query параметры (опционально)
       * @returns {string} URL для получения профиля студента
       */
      (gets = null) => getAccountsUrlWithParameters(
        'users|user|profile|student',
        'get',
        null,
        gets
      ),
    WORKER:
      /**
       * Получает профиль работника
       * @param {Object} gets - дополнительные query параметры (опционально)
       * @returns {string} URL для получения профиля работника
       */
      (gets = null) => getAccountsUrlWithParameters(
        'users|user|profile|worker',
        'get',
        null,
        gets
      ),
    ACCOUNT: {
      CHANGE_ACCOUNT:
        /**
         * Выполняет смену аккаунта
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для смены аккаунта
         */
        (gets = null) => getAccountsUrlWithParameters(
          'authenticate|authentication|change|account',
          'post',
          null,
          gets
        ),
    },
    SESSION: {
      LIST:
        /**
         * Получает список активных сессий
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для получения списка сессий
         */
        (gets = null) => getAccountsUrlWithParameters(
          'authenticate|authentication|session-list',
          'list',
          null,
          gets
        ),
      DELETE_ALL:
        /**
         * Удаляет все сессии пользователя
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для удаления всех сессий
         */
        (gets = null) => getAccountsUrlWithParameters(
          'authenticate|authentication|session-all',
          'all',
          {},
          gets
        ),
      DELETE:
        /**
         * Удаляет определенную сессию по ключу
         * @param {string} key - ключ сессии
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для удаления сессии
         */
        (key, gets = null) => getAccountsUrlWithParameters(
          'authenticate|authentication|session-detail',
          'destroy',
          { id: key },
          gets
        )
    },
    MAIL: {
      CREATE:
        /**
         * Добавляет почту пользователя
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для создания почты
         */
        (gets = null) => getAccountsUrlWithParameters(
          'users|contacts|emails-list',
          'create',
          null,
          gets
        ),
      UPDATE:
        /**
         * Обновляет почту пользователя
         * @param {string|number} id - идентификатор почты
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для обновления почты
         */
        (id, gets = null) => getAccountsUrlWithParameters(
          'users|contacts|emails-detail',
          'update',
          { id },
          gets
        ),
      DELETE:
        /**
         * Удаляет почту пользователя
         * @param {string|number} id - идентификатор почты
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для удаления почты
         */
        (id, gets = null) => getAccountsUrlWithParameters(
          'users|contacts|emails-detail',
          'destroy',
          { id },
          gets
        )
    },
    PHONE: {
      CREATE:
        /**
         * Добавляет телефонный номер
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для создания телефона
         */
        (gets = null) => getAccountsUrlWithParameters(
          'users|contacts|phones-list',
          'create',
          null,
          gets
        ),
      UPDATE:
        /**
         * Обновляет телефонный номер
         * @param {string|number} id - идентификатор телефона
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для обновления телефона
         */
        (id, gets = null) => getAccountsUrlWithParameters(
          'users|contacts|phones-detail',
          'update',
          { id },
          gets
        ),
      DELETE:
        /**
         * Удаляет телефонный номер
         * @param {string|number} id - идентификатор телефона
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для удаления телефона
         */
        (id, gets = null) => getAccountsUrlWithParameters(
          'users|contacts|phones-detail',
          'destroy',
          { id },
          gets
        )
    },
    LANGUAGE: {
      CREATE:
        /**
         * Добавляет язык пользователя
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для создания языка
         */
        (gets = null) => getAccountsUrlWithParameters(
          'users|user|languages-list',
          'create',
          null,
          gets
        ),
      UPDATE:
        /**
         * Обновляет язык пользователя
         * @param {string|number} id - идентификатор языка
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для обновления языка
         */
        (id, gets = null) => getAccountsUrlWithParameters(
          'users|user|languages-detail',
          'update',
          { id },
          gets
        ),
      DELETE:
        /**
         * Удаляет язык пользователя
         * @param {string|number} id - идентификатор языка
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для удаления языка
         */
        (id, gets = null) => getAccountsUrlWithParameters(
          'users|user|languages-detail',
          'destroy',
          { id },
          gets
        )
    },
    ADDRESS: {
      DELETE:
        /**
         * Удаляет адрес пользователя
         * @param {string|number} id - идентификатор адреса
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для удаления адреса
         */
        (id, gets = null) => getAccountsUrlWithParameters(
          'users|contacts|address-detail',
          'destroy',
          { id },
          gets
        ),
      DETAIL:
        /**
         * Получает детальную информацию об адресе
         * @param {string|number} id - идентификатор адреса
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для получения адреса
         */
        (id, gets = null) => getAccountsUrlWithParameters(
          'users|contacts|address-detail',
          'update',
          { id },
          gets
        ),
      CREATE:
        /**
         * Добавляет адрес пользователя
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для создания адреса
         */
        (gets = null) => getAccountsUrlWithParameters(
          'users|contacts|address-list',
          'create',
          null,
          gets
        ),
      UPDATE:
        /**
         * Обновляет адрес пользователя
         * @param {string|number} id - идентификатор адреса
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для обновления адреса
         */
        (id, gets = null) => getAccountsUrlWithParameters(
          'users|contacts|address-detail',
          'update',
          { id },
          gets
        )
    }
  }
}
